<template>
  <div class="contact-role">
    <FormSectionTitle>{{isCustomer ? 'Your' : 'Client'}} Role</FormSectionTitle>
    <span>What is your{{isCustomer ? '' : ' client\'s'}} role for this inspection?</span>
    <ContactRoleForm/>
  </div>
</template>

<script>
import { Constants } from '@spectorasoftware/homegauge-vue';
import { mapGetters } from 'vuex';

import ContactRoleForm from '@/components/ContactRoleForm.vue';
import FormSectionTitle from '@/components/FormSectionTitle.vue';

const { AccountTypes } = Constants;

export default {
  components: {
    ContactRoleForm,
    FormSectionTitle,
  },
  computed: {
    ...mapGetters('Auth', ['personType']),
    isCustomer() {
      return this.personType === AccountTypes.CUSTOMER;
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
